const mockUserService = {
  createRemoteSession: async ({ emailAddress }) => {
    return new Promise((resolve) => {
      window.setTimeout(() => {
        console.log('Remote session CREATE call done', emailAddress);
        const result = { status: 200 };
        resolve(result);
      }, 1000);
    });
  },

  completeRemoteSession: async () => {
    return new Promise((resolve) => {
      window.setTimeout(() => {
        console.log('Remote session COMPLETED call finished');
        const result = { status: 200 };
        resolve(result);
      }, 1000);
    });
  },
};

export default mockUserService;
